export const resetTime = date => {
    if (!(date instanceof Date)) {
        if(date.includes('T')) {
            date.split('T')
    
            date = date[0]
        }

        date += 'T23:59:00Z'

        date = new Date(date)
    }
    else {
        date.setUTCHours(23, 59, 0)
    }

    return date
}